import React, { useEffect, useState } from "react";
import { string, array, func } from "prop-types";

import HamburgerOne from "../HamburgerOne";
import HamburgerTwo from "../HamburgerTwo";

const Hamburger = ({ displayStyle = "", toggleHandler, hamburgerMenu, secondaryMenu }) => {
  const [isDesktop, setIsDesktop] = useState(null);

  useEffect(() => {
    if (global.deviceWidth > 1024) {
      setIsDesktop(true);
    }
  }, []);

  if (isDesktop) {
    return <HamburgerTwo hamburgerMenu={hamburgerMenu} toggleHandler={toggleHandler} />;
  }

  return (
    <HamburgerOne
      displayStyle={displayStyle}
      toggleHandler={toggleHandler}
      hamburgerMenu={hamburgerMenu}
      secondaryMenu={secondaryMenu}
    />
  );
};

Hamburger.propTypes = {
  displayStyle: string,
  toggleHandler: func,
  hamburgerMenu: array,
  secondaryMenu: array,
};

export default Hamburger;
